// extracted by mini-css-extract-plugin
export default {"my__profile":"Profile_my__profile__8h1b2","profile":"Profile_profile__GHgDE"};